import $ from "cash-dom";

export default (function () {
    $(document).ready(function () {
        jdmn.log("event_scroll-direction-change initialized", "green");

        var context = document.documentElement;
        var horizontal = false;
        var isVer = !horizontal;
        var historyLength = 32;
        var historyMaxAge = 512;
        var thresholdPixels = 96;
        var history = Array(historyLength);
        var pivotTime = 0;
        var pivot = isVer ? context.scrollTop : context.scrollLeft;
        var dir = isVer ? "down" : "right";
        var pos = "start";
        var y = 0;
        var py = 0;
        var callback = function () {
            window.dispatchEvent(
                new CustomEvent("scrollDirectionChange", {
                    detail: {
                        dir: dir,
                        pos: pos,
                    },
                })
            );
        };

        function tick() {
            const t = this.timeStamp;
            const furthest = dir === "down" || dir === "right" ? Math.max : Math.min;
            const yMax = isVer
                ? context.scrollHeight - context.clientHeight
                : context.scrollWidth - context.clientWidth;

            y = isVer ? context.scrollTop : context.scrollLeft;
            y = Math.max(0, y);
            y = Math.min(yMax, y);

            if ((pos == "start" && y >= thresholdPixels) || (pos == "end" && y <= yMax - thresholdPixels)) {
                pos = "scrolling";
                callback();
            }

            if (pos == "scrolling" && y <= thresholdPixels) {
                pos = "start";
                callback();
            }

            if (pos == "scrolling" && y >= yMax - thresholdPixels) {
                pos = "end";
                callback();
            }

            history.unshift({
                y,
                t,
            });
            history.pop();

            if (y === furthest(pivot, y)) {
                pivotTime = t;
                pivot = y;
                return;
            }

            const cutoffTime = t - historyMaxAge;
            if (cutoffTime > pivotTime) {
                pivot = y;
                for (let i = 0; i < historyLength; i += 1) {
                    if (!history[i] || history[i].t < cutoffTime) break;
                    pivot = furthest(pivot, history[i].y);
                }
            }

            if (Math.abs(y - pivot) > thresholdPixels) {
                pivot = y;
                pivotTime = t;

                if (isVer) {
                    dir = dir === "down" ? "up" : "down";
                } else {
                    dir = dir === "right" ? "left" : "right";
                }

                callback();
            }

            py = y;
        }

        callback();

        window.addEventListener("scroll", function (_e) {
            window.requestAnimationFrame(tick.bind(_e));
        });
    });
})();
